import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/Card";
import { Button } from "../components/ui/Button";
import { Input } from "../components/ui/Input";
import { Label } from "../components/ui/Label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/Select";
import { Textarea } from "../components/ui/Textarea";
import { Switch } from "../components/ui/Switch";
import { ArrowLeft, Save } from "lucide-react";

interface NovoClienteFormProps {
  onBack: () => void;
}

export function NovoClienteForm({ onBack }: NovoClienteFormProps) {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert("Cliente cadastrado com sucesso!");
    onBack();
  };

  return (
    <main className="flex-1 p-6 bg-gray-50">
      <div className="mb-6">
        <Button 
          variant="ghost" 
          onClick={onBack}
          className="mb-4 text-[#68686A] hover:text-[#D4C070]"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Voltar para Clientes
        </Button>
        <h1 className="text-2xl font-bold text-[#68686A]">Novo Cliente</h1>
        <p className="text-[#68686A]">Cadastrar um novo cliente</p>
      </div>
      
      <form onSubmit={handleSubmit} className="max-w-4xl space-y-6">
        <Card className="border border-gray-200 hover:shadow-md transition-shadow duration-200">
          <CardHeader>
            <CardTitle className="text-[#68686A]">Informações do Cliente</CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            {/* Linha 1: Código e Comissão FDC */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <Label htmlFor="codigo" className="text-sm font-medium text-[#68686A]">Cód</Label>
                <Input 
                  id="codigo" 
                  placeholder="Código do cliente"
                  className="border-gray-300 focus:ring-2 focus:ring-[#D4C070] focus:border-transparent"
                />
              </div>
              
              <div>
                <Label htmlFor="comissao-fdc" className="text-sm font-medium text-[#68686A]">Comissão FDC</Label>
                <div className="flex items-center">
                  <Input 
                    id="comissao-fdc" 
                    type="number" 
                    placeholder="0"
                    step="0.01"
                    className="border-gray-300 focus:ring-2 focus:ring-[#D4C070] focus:border-transparent"
                  />
                  <span className="ml-2 text-[#68686A]">%</span>
                </div>
              </div>
              
              <div className="flex items-center">
                <Switch id="bloquear-compras" />
                <Label htmlFor="bloquear-compras" className="ml-2 text-sm text-[#68686A]">Bloquear Compras</Label>
              </div>
            </div>
            
            {/* Linha 2: Nome */}
            <div>
              <Label htmlFor="nome" className="text-sm font-medium text-[#68686A]">Nome</Label>
              <Input 
                id="nome" 
                placeholder="Nome completo"
                className="border-gray-300 focus:ring-2 focus:ring-[#D4C070] focus:border-transparent"
              />
            </div>
            
            {/* Linha 3: Sobrenome */}
            <div>
              <Label htmlFor="sobrenome" className="text-sm font-medium text-[#68686A]">Sobrenome</Label>
              <Input 
                id="sobrenome" 
                placeholder="Sobrenome completo"
                className="border-gray-300 focus:ring-2 focus:ring-[#D4C070] focus:border-transparent"
              />
            </div>
            
            {/* Linha 4: Email */}
            <div>
              <Label htmlFor="email" className="text-sm font-medium text-[#68686A]">Email</Label>
              <Input 
                id="email" 
                type="email" 
                placeholder="email@dominio.com"
                className="border-gray-300 focus:ring-2 focus:ring-[#D4C070] focus:border-transparent"
              />
            </div>
            
            {/* Linha 5: CPF */}
            <div>
              <Label htmlFor="cpf" className="text-sm font-medium text-[#68686A]">CPF</Label>
              <Input 
                id="cpf" 
                placeholder="000.000.000-00"
                className="border-gray-300 focus:ring-2 focus:ring-[#D4C070] focus:border-transparent"
              />
            </div>
            
            {/* Linha 6: Celular */}
            <div>
              <Label htmlFor="celular" className="text-sm font-medium text-[#68686A]">Celular</Label>
              <Input 
                id="celular" 
                placeholder="(11) 99999-9999"
                className="border-gray-300 focus:ring-2 focus:ring-[#D4C070] focus:border-transparent"
              />
            </div>
            
            {/* Linha 7: CEP */}
            <div>
              <Label htmlFor="cep" className="text-sm font-medium text-[#68686A]">CEP</Label>
              <Input 
                id="cep" 
                placeholder="00000-000"
                className="border-gray-300 focus:ring-2 focus:ring-[#D4C070] focus:border-transparent"
              />
            </div>
            
            {/* Linha 8: Endereço, Número, Complemento */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <Label htmlFor="endereco" className="text-sm font-medium text-[#68686A]">Endereço</Label>
                <Input 
                  id="endereco" 
                  placeholder="Rua, Avenida, etc."
                  className="border-gray-300 focus:ring-2 focus:ring-[#D4C070] focus:border-transparent"
                />
              </div>
              
              <div>
                <Label htmlFor="numero" className="text-sm font-medium text-[#68686A]">Número</Label>
                <Input 
                  id="numero" 
                  placeholder="Número"
                  className="border-gray-300 focus:ring-2 focus:ring-[#D4C070] focus:border-transparent"
                />
              </div>
              
              <div>
                <Label htmlFor="complemento" className="text-sm font-medium text-[#68686A]">Complemento</Label>
                <Input 
                  id="complemento" 
                  placeholder="Apto, bloco, andar, etc."
                  className="border-gray-300 focus:ring-2 focus:ring-[#D4C070] focus:border-transparent"
                />
              </div>
            </div>
            
            {/* Linha 9: Bairro, Cidade, Estado */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <Label htmlFor="bairro" className="text-sm font-medium text-[#68686A]">Bairro</Label>
                <Input 
                  id="bairro" 
                  placeholder="Bairro"
                  className="border-gray-300 focus:ring-2 focus:ring-[#D4C070] focus:border-transparent"
                />
              </div>
              
              <div>
                <Label htmlFor="cidade" className="text-sm font-medium text-[#68686A]">Cidade</Label>
                <Input 
                  id="cidade" 
                  placeholder="Cidade"
                  className="border-gray-300 focus:ring-2 focus:ring-[#D4C070] focus:border-transparent"
                />
              </div>
              
              <div>
                <Label htmlFor="estado" className="text-sm font-medium text-[#68686A]">Estado</Label>
                <Select>
                  <SelectTrigger className="border-gray-300 focus:ring-2 focus:ring-[#D4C070] focus:border-transparent">
                    <SelectValue placeholder="UF" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="SP">SP</SelectItem>
                    <SelectItem value="RJ">RJ</SelectItem>
                    <SelectItem value="MG">MG</SelectItem>
                    <SelectItem value="RS">RS</SelectItem>
                    <SelectItem value="PR">PR</SelectItem>
                    <SelectItem value="BA">BA</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
            
            {/* Linha 10: Observações */}
            <div>
              <Label htmlFor="observacoes" className="text-sm font-medium text-[#68686A]">Observações</Label>
              <Textarea 
                id="observacoes" 
                placeholder="Observações sobre o cliente..."
                rows={3}
                className="border-gray-300 focus:ring-2 focus:ring-[#D4C070] focus:border-transparent"
              />
            </div>
          </CardContent>
        </Card>

        <div className="flex gap-4">
          <Button 
            type="button" 
            variant="outline"
            onClick={onBack}
            className="border-gray-300 text-[#68686A] hover:bg-[#EEF1F2]"
          >
            Cancelar
          </Button>
          <Button 
            type="submit" 
            className="flex-1 bg-[#D4C070] hover:bg-[#849D70] text-white"
          >
            <Save className="h-4 w-4 mr-2" />
            SALVAR
          </Button>
        </div>
      </form>
    </main>
  );
}


export default NovoClienteForm;
